import React from 'react';
import { XCircle } from 'lucide-react';

/**
 * 공통 검색 입력창 컴포넌트.
 * 왼쪽 아이콘 주입 및 우측 'X' 버튼(Clear) 기능을 포함합니다.
 */
const CommonSearchInput = ({
    value = '',
    onChange,
    onClear,
    placeholder = '검색어를 입력하세요.',
    icon: Icon,
    className = '',
    containerClassName = '',
    height = 'h-11'
}) => {
    // 초기화 핸들러: 별도 onClear가 없으면 onChange('') 호출
    const handleClear = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClear) {
            onClear();
        } else if (onChange) {
            onChange({ target: { value: '' } });
        }
    };

    return (
        <div className={`relative flex-1 ${containerClassName}`}>
            {/* 왼쪽 아이콘 */}
            {Icon && (
                <Icon 
                    size={18} 
                    className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none transition-colors group-focus-within:text-blue-500" 
                />
            )}
            
            {/* 입력창 */}
            <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className={`
                    w-full ${height} pl-11 pr-10 
                    bg-white border border-gray-200 rounded-full 
                    outline-none text-[14px] transition-all duration-200
                    focus:border-blue-400 focus:ring-4 focus:ring-blue-50/50
                    placeholder:text-gray-400
                    ${className}
                `}
            />

            {/* 우측 'X' 버튼 (값이 있을 때만 표시) */}
            {value && (
                <button
                    onClick={handleClear}
                    type="button"
                    className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-blue-300 hover:text-blue-600 hover:scale-110 transition-all duration-200 active:scale-95"
                    title="검색어 초기화"
                >
                    <XCircle size={20} fill="#eff6ff" /> {/* bg-blue-50(Hex: #eff6ff)으로 내부 채움 */}
                </button>
            )}
        </div>
    );
};

export default CommonSearchInput;
